<template>
  <div class="item">
    <b class="title required">届出内容</b>
    <input-textarea v-model="idou.todokede1_naiyou" :error="getError(idou, 'todokede1_naiyou')" ></input-textarea>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useForm } from "@/composable/form/form";
import {  Idou } from '@/types/Shinsei';
export default defineComponent({
  props:{
    idou: {
      type: Object as () => Idou,
      default: null
    },
  },
  setup(props) {

    // エラー取得
    const { getError } = useForm();

    return {
      getError,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
